(() => {
  if (window.__hrShadowCaptureReady) return;
  window.__hrShadowCaptureReady = true;
  window.__hrCapturedShadowRoots = window.__hrCapturedShadowRoots || [];

  const nativeAttachShadow = Element.prototype.attachShadow;
  if (!nativeAttachShadow) return;

  Element.prototype.attachShadow = function (init) {
    const root = nativeAttachShadow.call(this, init);
    try {
      window.__hrCapturedShadowRoots.push(root);
      window.dispatchEvent(new CustomEvent('hr:shadowroot', { detail: root }));
    } catch (e) {}
    return root;
  };
})();

(() => {
  const SELECTOR = '.hrp[data-hrp-root]';

  const normalize = (src) => {
    if (!src) return '';
    try { return new URL(src, window.location.href).pathname; }
    catch (e) { return String(src).split('?')[0]; }
  };

  const large = (src) => {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.href);
      url.searchParams.set('width', '1500');
      return url.toString();
    } catch (e) { return src; }
  };

  function initGallery(root) {
    if (!root || root.dataset.hrGalleryNavReady === 'true') return;

    const mainMedia = root.querySelector('.hrp__main-media');
    const mainImage = root.querySelector('.hrp__main-image');
    const rawThumbs = Array.from(root.querySelectorAll('[data-hrp-thumb]'));
    if (!mainMedia || !mainImage || rawThumbs.length < 2) return;

    const seen = new Set();
    const thumbs = [];

    rawThumbs.forEach((thumb) => {
      const key = normalize(thumb.dataset.imageSrc);
      if (key && seen.has(key)) {
        thumb.hidden = true;
        thumb.style.display = 'none';
        thumb.setAttribute('aria-hidden', 'true');
        thumb.tabIndex = -1;
        thumb.classList.remove('is-active');
        return;
      }
      if (key) seen.add(key);
      thumbs.push(thumb);
    });

    if (thumbs.length < 2) return;

    root.dataset.hrGalleryNavReady = 'true';
    mainMedia.classList.add('hrp__main-media--interactive');
    mainMedia.tabIndex = 0;
    mainMedia.setAttribute('role', 'group');
    mainMedia.setAttribute('aria-label', 'Product image gallery');

    mainMedia.querySelectorAll('.hrp__gallery-arrow,.hrp__carousel-arrow').forEach(el => el.remove());

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'hrp__gallery-arrow hrp__gallery-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = '<span aria-hidden="true">‹</span>';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'hrp__gallery-arrow hrp__gallery-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = '<span aria-hidden="true">›</span>';

    mainMedia.append(prev, next);

    let index = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));
    let controlsTimer = null;
    let startX = null;
    let startY = null;
    let suppressClick = false;

    function setActive(i) {
      index = (i + thumbs.length) % thumbs.length;
      const thumb = thumbs[index];
      const src = thumb.dataset.imageSrc;

      if (src) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = large(src);
        const img = thumb.querySelector('img');
        if (img?.alt) mainImage.alt = img.alt;
      }

      rawThumbs.forEach(item => {
        item.classList.remove('is-active');
        item.removeAttribute('aria-current');
      });

      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');
    }

    function syncFromImage() {
      const path = normalize(mainImage.currentSrc || mainImage.src);
      const match = thumbs.findIndex(t => normalize(t.dataset.imageSrc) === path);
      if (match >= 0) {
        index = match;
        rawThumbs.forEach(item => {
          item.classList.remove('is-active');
          item.removeAttribute('aria-current');
        });
        thumbs[index].classList.add('is-active');
        thumbs[index].setAttribute('aria-current', 'true');
      }
    }

    function showControls() {
      mainMedia.classList.add('is-gallery-active');
      clearTimeout(controlsTimer);
      controlsTimer = setTimeout(() => mainMedia.classList.remove('is-gallery-active'), 1400);
    }

    function go(delta) {
      const currentPath = normalize(mainImage.currentSrc || mainImage.src);
      let nextIndex = index;
      let attempts = 0;

      do {
        nextIndex = (nextIndex + delta + thumbs.length) % thumbs.length;
        attempts += 1;
      } while (
        attempts < thumbs.length &&
        normalize(thumbs[nextIndex].dataset.imageSrc) === currentPath
      );

      setActive(nextIndex);
      showControls();
    }

    prev.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      go(-1);
    });

    next.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      go(1);
    });

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        index = i;
        setTimeout(syncFromImage, 0);
      }, true);
    });

    mainMedia.addEventListener('click', e => {
      if (e.target.closest('.hrp__gallery-arrow')) return;
      if (suppressClick) {
        suppressClick = false;
        return;
      }
      const rect = mainMedia.getBoundingClientRect();
      go(e.clientX - rect.left < rect.width / 2 ? -1 : 1);
    });

    mainMedia.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });

    mainMedia.addEventListener('pointerdown', e => {
      if (e.target.closest('.hrp__gallery-arrow')) return;
      startX = e.clientX;
      startY = e.clientY;
      showControls();
    });

    mainMedia.addEventListener('pointerup', e => {
      if (startX == null || startY == null) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      startX = null;
      startY = null;
      if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy)) {
        suppressClick = true;
        go(dx < 0 ? 1 : -1);
        setTimeout(() => { suppressClick = false; }, 350);
      }
    });

    mainMedia.addEventListener('pointercancel', () => {
      startX = null;
      startY = null;
    });

    mainMedia.addEventListener('mouseenter', showControls);
    mainMedia.addEventListener('mousemove', showControls);
    mainMedia.addEventListener('focusin', showControls);
    mainMedia.addEventListener('mouseleave', () => {
      clearTimeout(controlsTimer);
      mainMedia.classList.remove('is-gallery-active');
    });

    new MutationObserver(syncFromImage).observe(mainImage, {
      attributes: true,
      attributeFilter: ['src', 'srcset']
    });

    syncFromImage();
  }

  function initAll(scope = document) {
    if (scope.matches?.(SELECTOR)) initGallery(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', e => initAll(e.target || document));
})();

(() => {
  const LABEL_RE = /(?:coat\s+of\s+arms|stemma(?:\s+di\s+famiglia)?)/i;
  const URL_RE = /https?:\/\/[^\s<>"']+/i;
  const DESIGN_URL_RE = /(?:hrngs\.co\/f\/|\/uploads\/|cdn\.shopify\.com\/.*\.(?:png|jpe?g|webp|gif|svg))/i;
  const BUTTON_CLASS = 'hr-design-preview-button';
  const MODAL_CLASS = 'hr-design-preview-modal';
  const observedRoots = new WeakSet();
  let lastTrigger = null;

  const isItalian = () => String(document.documentElement.lang || '').toLowerCase().startsWith('it');
  const buttonLabel = () => isItalian() ? 'Vedi design' : 'View design';
  const closeLabel = () => isItalian() ? 'Chiudi anteprima' : 'Close preview';
  const cleanUrl = (value) => String(value || '').trim().replace(/[),.;]+$/, '');
  const isDesignUrl = (value) => DESIGN_URL_RE.test(cleanUrl(value));

  const styles = `
    .${BUTTON_CLASS}{appearance:none;-webkit-appearance:none;display:inline-flex;align-items:center;justify-content:center;margin-left:5px;padding:3px 8px;border:1px solid #d5a33a;border-radius:4px;background:#fff;color:#111;font:inherit;font-size:.92em;font-weight:600;line-height:1.2;cursor:pointer;vertical-align:middle;white-space:nowrap}
    .${BUTTON_CLASS}:hover{background:#fbf8f1}
    .${BUTTON_CLASS}:focus-visible{outline:2px solid #111;outline-offset:2px}
    .${MODAL_CLASS}{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(0,0,0,.72)}
    .${MODAL_CLASS}[hidden]{display:none!important}
    .${MODAL_CLASS}__panel{position:relative;width:min(620px,92vw);max-height:86vh;padding:14px;background:#fff;border-radius:10px;box-shadow:0 16px 48px rgba(0,0,0,.22);display:flex;align-items:center;justify-content:center}
    .${MODAL_CLASS}__image{display:block;max-width:100%;max-height:78vh;width:auto;height:auto;object-fit:contain}
    .${MODAL_CLASS}__frame{display:none;width:100%;height:min(76vh,720px);border:0;background:#fff}
    .${MODAL_CLASS}__close{position:absolute;top:-18px;right:-18px;z-index:2;width:38px;height:38px;border:1px solid rgba(0,0,0,.08);border-radius:50%;background:#fff;color:#111;font:inherit;font-size:22px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.16)}
    @media(max-width:749px){.${MODAL_CLASS}{padding:18px}.${MODAL_CLASS}__panel{width:min(94vw,620px);padding:10px}.${MODAL_CLASS}__close{top:-14px;right:-10px;width:36px;height:36px}}
  `;

  function ensureStyles(root) {
    const host = root instanceof ShadowRoot ? root : document.head;
    if (!host || host.querySelector?.('style[data-hr-design-preview-styles]')) return;
    const style = document.createElement('style');
    style.dataset.hrDesignPreviewStyles = 'true';
    style.textContent = styles;
    host.appendChild(style);
  }

  function getModal() {
    let modal = document.querySelector(`.${MODAL_CLASS}`);
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = MODAL_CLASS;
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', isItalian() ? 'Anteprima design' : 'Design preview');
    modal.innerHTML = `
      <div class="${MODAL_CLASS}__panel" role="document">
        <button type="button" class="${MODAL_CLASS}__close" aria-label="${closeLabel()}">×</button>
        <img class="${MODAL_CLASS}__image" alt="Coat of Arms preview">
        <iframe class="${MODAL_CLASS}__frame" title="Coat of Arms preview"></iframe>
      </div>`;
    document.body.appendChild(modal);

    modal.querySelector(`.${MODAL_CLASS}__close`)?.addEventListener('click', (event) => {
      event.preventDefault();
      closeModal();
    });
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    return modal;
  }

  function closeModal() {
    const modal = document.querySelector(`.${MODAL_CLASS}`);
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    const image = modal.querySelector(`.${MODAL_CLASS}__image`);
    const frame = modal.querySelector(`.${MODAL_CLASS}__frame`);
    if (image) { image.removeAttribute('src'); image.style.display = ''; }
    if (frame) { frame.removeAttribute('src'); frame.style.display = 'none'; }
    lastTrigger?.focus?.({ preventScroll: true });
    lastTrigger = null;
  }

  function openModal(url, trigger) {
    if (!url) return;
    const modal = getModal();
    const image = modal.querySelector(`.${MODAL_CLASS}__image`);
    const frame = modal.querySelector(`.${MODAL_CLASS}__frame`);
    lastTrigger = trigger || null;
    modal.hidden = false;
    frame.style.display = 'none';
    image.style.display = '';
    image.onerror = () => {
      image.style.display = 'none';
      frame.style.display = 'block';
      frame.src = url;
    };
    image.src = url;
  }

  function createButton(url) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = BUTTON_CLASS;
    button.dataset.hrDesignSrc = cleanUrl(url);
    button.textContent = buttonLabel();
    button.setAttribute('aria-label', `${buttonLabel()} - Coat of Arms`);
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openModal(button.dataset.hrDesignSrc, button);
    });
    return button;
  }

  function contextHasLabel(node) {
    let el = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
    for (let depth = 0; el && depth < 6; depth += 1, el = el.parentElement) {
      const text = String(el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.length <= 900 && LABEL_RE.test(text)) return true;
    }
    return false;
  }

  function patchAnchor(anchor) {
    if (!anchor || anchor.classList?.contains(BUTTON_CLASS)) return;
    const url = cleanUrl(anchor.getAttribute('href') || anchor.textContent);
    if (!isDesignUrl(url) || !contextHasLabel(anchor)) return;
    anchor.replaceWith(createButton(url));
  }

  function patchTextNode(node) {
    if (!node || !node.nodeValue || !node.parentElement) return;
    if (node.parentElement.closest(`script,style,button,textarea,input,.${MODAL_CLASS}`)) return;
    const match = node.nodeValue.match(URL_RE);
    if (!match) return;
    const url = cleanUrl(match[0]);
    if (!isDesignUrl(url) || !contextHasLabel(node)) return;

    const before = node.nodeValue.slice(0, match.index || 0);
    const after = node.nodeValue.slice((match.index || 0) + match[0].length);
    const fragment = document.createDocumentFragment();
    if (before) fragment.appendChild(document.createTextNode(before));
    fragment.appendChild(createButton(url));
    if (after) fragment.appendChild(document.createTextNode(after));
    node.replaceWith(fragment);
  }

  function patchRoot(root) {
    if (!root) return;
    ensureStyles(root);

    if (root.nodeType === Node.ELEMENT_NODE && root.matches?.('a[href]')) patchAnchor(root);
    root.querySelectorAll?.('a[href]').forEach(patchAnchor);

    if (root.nodeType === Node.TEXT_NODE) {
      patchTextNode(root);
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !URL_RE.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        const parent = node.parentElement;
        if (!parent || parent.closest(`script,style,button,textarea,input,.${MODAL_CLASS}`)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(patchTextNode);

    root.querySelectorAll?.('*').forEach((el) => {
      if (el.shadowRoot) observeRoot(el.shadowRoot);
    });
  }

  function observeRoot(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);
    patchRoot(root);
    try {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((added) => {
            if (added.nodeType === Node.ELEMENT_NODE || added.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
              patchRoot(added);
              if (added.shadowRoot) observeRoot(added.shadowRoot);
            } else if (added.nodeType === Node.TEXT_NODE) {
              patchTextNode(added);
            }
          });
          if (mutation.type === 'characterData') patchTextNode(mutation.target);
        });
      });
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
  }

  function inspectFrames() {
    document.querySelectorAll('iframe').forEach((frame) => {
      try {
        const doc = frame.contentDocument;
        if (doc?.body) observeRoot(doc.body);
      } catch (e) {}
    });
  }

  function init() {
    ensureStyles(document);
    if (document.body) observeRoot(document.body);
    (window.__hrCapturedShadowRoots || []).forEach(observeRoot);
    window.addEventListener('hr:shadowroot', (event) => observeRoot(event.detail));
    inspectFrames();
    window.setInterval(inspectFrames, 1200);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
